import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'payroll_records_do_not_show_types_social_insurance'

export const dataPointDefinition = {
  retracedId: 'payroll_records_do_not_show_types_social_insurance',
  name: 'Payroll records do not show all the types of social insurance the workers are paid',
  description:
    'The intent of this option selection is to understand if records reflect the types of social insurance/ social security the workers are provided. Payroll records should be consistent with the types of social insurance/ social security listed under the category Social Insurance/ Social Security in thi',
  meta: {
    slcpMeta: {
      key: 'wb-wage-1',
      number: 'WB-WAGE-3-3',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-wage-1', version: '1.7.0', provider: 'slcp'}],
  sortingId: 35890,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
